// Races a promise against a timeout WITHOUT touching whatever it's doing
// internally (unlike wrapping supabase-js's own cross-tab lock, which risks
// invoking its internal critical section twice and deadlocking in pure JS —
// that's what caused an earlier "page load hangs forever, network tab looks
// clean" bug). If the real promise resolves late, it's simply ignored here;
// the caller must still be corrected by whatever ongoing subscription (e.g.
// onAuthStateChange) reflects the eventual real state.
export function withTimeout<T>(promise: Promise<T>, ms: number, fallback: T): Promise<T> {
  return new Promise((resolve) => {
    const timer = setTimeout(() => resolve(fallback), ms);
    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      () => {
        clearTimeout(timer);
        resolve(fallback);
      },
    );
  });
}
